module.exports = __webpack_public_path__ + "static/media/b4.7b209e9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangping/b4.mp3
// module id = XLlo
// module chunks = 0